import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const R4Main = lazy(() => import('../r4draft/R4Main'));
const R4LiveDraft = lazy(() => import('../r4draft/R4LiveDraft'));
const R4DraftDayBoc = lazy(() => import('../r4draft/R4DraftDayBoc'));
const R4BocPlayerListing = lazy(
  () => import('../r4draft/r4components/R4BocPlayerListing')
);
const R4DraftDayClub = lazy(() => import('../r4draft/R4DraftDayClub'));
const R4DraftDisplay = lazy(() => import('../r4draft/R4DraftDisplay'));
const R4Connectivity = lazy(() => import('../r4draft/R4Connectivity'));
const R4DraftTestPicker = lazy(() => import('../r4draft/R4DraftTestPicker'));
const R4DraftOrder = lazy(() => import('../r4draft/R4DraftOrder'));
const R4PreDraft = lazy(() => import('../r4draft/R4PreDraft'));
const R4CommScreenEditor = lazy(() => import('../r4draft/R4CommScreenEditor'));
const R4PostDraft = lazy(() => import('../r4draft/R4PostDraft'));

export default [
  {
    id: NavConfig.groupConfigs.RULE_4.id,
    path: NavConfig.groupConfigs.RULE_4.to,
    element: (
      <R4Main>
        <Suspense>
          <Outlet />
        </Suspense>
      </R4Main>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={NavConfig.linkConfigs.R4_PRE_DRAFT.to} />,
      },
      {
        id: NavConfig.linkConfigs.R4_DRAFT_LIVE.id,
        path: NavConfig.linkConfigs.R4_DRAFT_LIVE.to,
        element: (
          <R4LiveDraft>
            <Suspense>
              <Outlet />
            </Suspense>
          </R4LiveDraft>
        ),
        children: [
          {
            id: NavConfig.linkConfigs.R4_DRAFT_ORDER.id,
            path: NavConfig.linkConfigs.R4_DRAFT_ORDER.to,
            element: <R4DraftOrder />,
          },
          {
            id: NavConfig.linkConfigs.R4_PRE_DRAFT.id,
            path: NavConfig.linkConfigs.R4_PRE_DRAFT.to,
            element: <R4PreDraft />,
          },
          {
            id: NavConfig.linkConfigs.R4_DRAFT_DAY_BOC.id,
            path: NavConfig.linkConfigs.R4_DRAFT_DAY_BOC.to,
            element: <R4DraftDayBoc />,
          },
          {
            id: NavConfig.linkConfigs.R4_BOC_PLAYER_LISTING.id,
            path: NavConfig.linkConfigs.R4_BOC_PLAYER_LISTING.to,
            element: <R4BocPlayerListing />,
          },
          {
            id: NavConfig.linkConfigs.R4_DRAFT_DAY_CLUB.id,
            path: NavConfig.linkConfigs.R4_DRAFT_DAY_CLUB.to,
            element: <R4DraftDayClub />,
          },
          {
            id: NavConfig.linkConfigs.R4_DRAFT_DISPLAY.id,
            path: NavConfig.linkConfigs.R4_DRAFT_DISPLAY.to,
            element: <R4DraftDisplay />,
          },
          {
            id: NavConfig.linkConfigs.R4_POST_DRAFT.id,
            path: NavConfig.linkConfigs.R4_POST_DRAFT.to,
            element: <R4PostDraft />,
          },
          {
            id: NavConfig.linkConfigs.R4_CONNECTIVITY.id,
            path: NavConfig.linkConfigs.R4_CONNECTIVITY.to,
            element: <R4Connectivity />,
          },
          {
            id: NavConfig.linkConfigs.R4_DRAFT_TEST_PICKER.id,
            path: NavConfig.linkConfigs.R4_DRAFT_TEST_PICKER.to,
            element: <R4DraftTestPicker />,
          },
          {
            id: NavConfig.linkConfigs.R4_COMM_SCREEN_EDITOR.id,
            path: NavConfig.linkConfigs.R4_COMM_SCREEN_EDITOR.to,
            element: <R4CommScreenEditor />,
          },
        ],
      },
    ],
  },
];
